import { Pipe, PipeTransform } from '@angular/core';
import { AGENCY_STATUS } from 'ag-common-lib/lib/lists/agency-status.enum';

@Pipe({ name: 'agencyStatusBanIcon' })
export class AgencyStatusBanIconPipe implements PipeTransform {
  transform(agencyStatus: string): string {
    const cssClassName = {
      [AGENCY_STATUS.DENIED]: 'danger',
    };
    return cssClassName[agencyStatus] || 'normal';
  }
}
